import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth-context";
import { MaintenanceGuard } from "@/components/common/MaintenanceGuard";
import { initializeAnalyticsIfConsented } from "@/lib/analytics";
import App from "./App";
import "./index.css";

// Initialize analytics if user has previously consented
initializeAnalyticsIfConsented();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <MaintenanceGuard>
              <App />
            </MaintenanceGuard>
            <Toaster
              position="top-right"
              richColors
              closeButton
              expand={true}
              visibleToasts={5}
              gap={8}
            />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);
